import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=498def55"
import script from "./Route.vue?vue&type=script&lang=js"
export * from "./Route.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports